export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywacja czeku elektronicznego"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rachunek depozytowy"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numer"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seria"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kod aktywacyjny"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sprawdzać"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywuj czek elektroniczny"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kwota"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywny"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowany"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anulowany"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktywowanie"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zwrot"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Oczekujący"])}
  }
}